"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguageFromCountry = void 0;
/**
 * Returns the country language by mapping the country to one of our supported languages
 */
function getLanguageFromCountry(country) {
    if (!country) {
        return 'nl';
    }
    if (country.length === 0) {
        return 'nl';
    }
    if (country.includes('nl')) {
        return 'nl';
    }
    return 'en';
}
exports.getLanguageFromCountry = getLanguageFromCountry;
//# sourceMappingURL=get-language-from-country.js.map